import Swiper, { Navigation, Pagination, Lazy, Autoplay, EffectFade } from 'swiper';
Swiper.use([Navigation, Pagination, Lazy, Autoplay, EffectFade]);

import Component from 'gia/Component'

export default class PostSwiperComponent extends Component {
  
  constructor(element) {
    super(element);
    this.ref = {
      pagination: null,
      next: null,
      prev: null
    }
  }
  
  mount() {
    
    const opts = {
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 4,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
    }
    
    
    const autoplay_opt = this.element.dataset.autoplay
    const navigation_opt = this.element.dataset.navigation
    const pagination_opt = this.element.dataset.pagination
    const spacing_opt = this.element.dataset.spacing
    const slides_opt = this.element.dataset.count
    const direction_opt = this.element.dataset.direction
    const loop_opt = this.element.dataset.loop
    const speed_opt = this.element.dataset.speed
    const center_opt = this.element.dataset.center
    const autoheight_opt = this.element.dataset.autoheight
    // const code_opt = this.element.dataset.code 
    
    if (center_opt) {
      opts.centeredSlides = true
    }

    if (autoheight_opt) {
      opts.autoHeight = true
    }
    
    if (slides_opt) {
      opts.slidesPerView = parseInt(slides_opt)
    }
    
    if (spacing_opt) {
      opts.spaceBetween = parseInt(spacing_opt)
    }
    
    if (direction_opt) {
      opts.direction = direction_opt
    }
    
    if (loop_opt) {
      opts.loop = true
    }
    
    if (speed_opt) {
      opts.speed = parseInt(speed_opt)
    }
    
    if (pagination_opt) {
      opts.pagination = {
        el: this.ref.pagination,
        clickable: true,
      }
    }
    
    if (navigation_opt) {
      opts.navigation = {
        nextEl: this.ref.next,
        prevEl: this.ref.prev
      }
    }
    
    if (autoplay_opt) {
      opts.autoplay = {
        delay: parseInt(autoplay_opt)
      }
    }
    
    // console.log(JSON.parse(code_opt));
    
    const swiper = new Swiper(this.element, opts);
    
  }
}